(function ($) {
    $.fn.scrollAnimate = function (options) {
        // Default settings
        const defaults = {
            speed: '0.5s',
            delay: '0s',
            offset: '100px',
            once: false,
            out: false,
            interpolate: false
        };

        return this.each(function () {
            const $el = $(this);

            // Merge data attributes and JS options
            const settings = $.extend({}, defaults, options, {
                speed: $el.data('animate-speed'),
                delay: $el.data('animate-delay'),
                offset: $el.data('animate-offset'),
                once: $el.data('animate-once') !== undefined ? !!$el.data('animate-once') : undefined,
                out: $el.data('animate-out') !== undefined ? !!$el.data('animate-out') : undefined,
                interpolate: $el.data('animate-interpolate') !== undefined ? !!$el.data('animate-interpolate') : undefined
            });

            // Skip if IntersectionObserver is not supported
            if (!window.IntersectionObserver) {
                $el.addClass('is-animated');
                return;
            }

            // Apply dynamic transition styles
            $el.css({
                'transition-duration': settings.speed,
                'transition-delay': settings.delay
            });

            // Calculate effective offset based on element height
            const elementHeight = $el.outerHeight();
            const effectiveOffset = Math.min(parseFloat(settings.offset), elementHeight);

            // Set up IntersectionObserver
            const observer = new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    const isIntersecting = entry.isIntersecting;
                    const isScrollingUp = entry.boundingClientRect.top > entry.rootBounds.bottom;

                    if (settings.interpolate) {
                        // Placeholder for future scroll interpolation
                        // handleInterpolatedAnimation($el, entry, settings);
                    } else {
                        console.log(settings);
                        if ($el.data('animate') === 'count-up') {
                            handleCountUpAnimation($el, settings);
                        }
                        handleNormalAnimation($el, isIntersecting, isScrollingUp, settings, obs);
                    }
                });
            }, {
                rootMargin: `0px 0px -${effectiveOffset}px 0px`,
                threshold: 0
            });

            observer.observe($el[0]);
        });

        // Normal animation logic
        function handleNormalAnimation($el, isIntersecting, isScrollingUp, settings, observer) {
            const isAnimated = $el.hasClass('is-animated');
        
            if (isIntersecting && !isAnimated && !isScrollingUp) {
                // Animate in when entering viewport from the bottom
                $el.addClass('is-animated');

                if (settings.once) {
                    observer.unobserve($el[0]);
                }
            } else if (!isIntersecting && isAnimated && settings.out && !settings.once && isScrollingUp) {
                // Animate out when leaving viewport bottom (scrolling up)
                $el.removeClass('is-animated');
            } else if (!isIntersecting && isAnimated && !settings.out && !settings.once && isScrollingUp) {
                // Reset to initial state when leaving viewport bottom (scrolling up, no out animation)
                $el.removeClass('is-animated');
            }
        }

        // Encapsulated count-up animation logic

        function handleCountUpAnimation($el, settings) {
            let data = $el.data('countup');

            if (!data) {
                const text = $el.text().trim();
                const match = text.match(/([^0-9]*)([\d,]+)([^0-9]*)/);
                if (!match) return;

                const [, prefix, numberStr, suffix] = match;
                const target = parseInt(numberStr.replace(/,/g, ''), 10);
                data = { prefix, target, suffix };
                $el.data('countup', data);
            }

            const { prefix, target, suffix } = data;
            const duration = parseTime(settings.speed || '1000ms');
            const delay = parseTime(settings.delay || '0ms');
            const once = settings.once;

            if ($el.hasClass('is-animated')) {
                if (once) return; 
                else $el.text(`${prefix}0${suffix}`);
            }

            const start = performance.now() + delay;

            const frame = (now) => {
                const elapsed = now - start;

                if (elapsed < 0) {
                    requestAnimationFrame(frame);
                    return;
                }

                const progress = Math.min(elapsed / duration, 1);
                const eased = easeOutCubic(progress);

                let current;
                if (target <= 100) {
                    current = Math.round(eased * target);
                } else {
                    const steps = 50;
                    const maxIncrement = target / steps;
                    const approx = eased * target;
                    current = Math.floor(approx - (1 - eased) * maxIncrement * 3);
                    current = Math.min(current, target);
                }

                // ✅ format with thousand separators
                const formatted = current.toLocaleString();

                $el.text(`${prefix}${formatted}${suffix}`);

                if (progress < 1) {
                    requestAnimationFrame(frame);
                }
            };

            requestAnimationFrame(frame);

            // Helpers
            function parseTime(str) {
                return str.endsWith('ms') ? parseFloat(str)
                    : str.endsWith('s') ? parseFloat(str) * 1000
                    : 0;
            }

            function easeOutCubic(t) {
                return 1 - Math.pow(1 - t, 3);
            }
        }

          
    };
})(jQuery);

// $(document).ready(() => $('[data-animate]').scrollAnimate()); // Initialize on DOM ready